import PropTypes from 'prop-types';
import './Skill.scss';
import SectionHeading from '../SectionHeading/SectionHeading';

const Skill = ({ data }) => {
  const { title, text, skills } = data;
  return (
    <section className="st-dark-bg">
      <div className="st-height-b100 st-height-lg-b80"></div>
      <SectionHeading title="Skills" />
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="st-skill-wrap">
              <div
                className="st-skill-heading"
                data-aos="fade-right"
                data-aos-duration="800"
              >
                <h2 className="st-skill-title">{title}</h2>
                <div className="st-skill-subtitle">{text}</div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="st-skill-list">
              {typeof skills === 'string' 
                ? skills.split('|').map((skill, index) => (
                    <div
                      className="st-skill-item"
                      key={index}
                      data-aos="fade-up"
                      data-aos-duration="500"
                      data-aos-delay={index * 100}
                    >
                      <p className="st-skill-name">{skill.trim()}</p>
                    </div>
                  ))
                : skills.map((element, index) => (
                    <div
                      className="st-skill-item"
                      key={index}
                      data-aos={element.effect}
                      data-aos-duration={element.duration}
                      data-aos-delay={element.delay}
                    >
                      <p className="st-skill-name">{element.title}</p>
                    </div>
                  ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Skill.propTypes = {
  data: PropTypes.object,
};

export default Skill;
